<template>
  <div class="infoAboutDelivery">
    <div class="info" v-if="activeReservations.phoneNumber">
      <p>{{ $t('mobilePhone') }}</p>
      <span>{{ activeReservations.phoneNumber }}</span>
    </div>
    <div class="info" v-if="activeReservations.deliveryStatus">
      <p>{{ $t('deliveryStatus') }}</p>
      <span>{{ $t(activeReservations.deliveryStatus) }}</span>
    </div>
    <div class="info">
      <p>{{ $t('ssn') }}</p>
      <span>{{ getDataSSN() }}</span>
      <Button
        v-if="!isSSN && !showDecodedSsn"
        class="ssn_btn"
        variant="notBordered"
        :title="$t('show')"
        @click="showSsn"
      />
    </div>
    <div class="info" v-if="activeReservations.expiredTime">
      <p>{{ $t('timeExpired') }}</p>
      <span>{{ dateTime(activeReservations.expiredTime) }}</span>
    </div>
    <div class="info" v-if="activeReservations.deliveryId">
      <p>{{ $t('kolliID') }}</p>
      <span>
        {{
          getIds(
            activeReservations.deliveryId,
            activeReservations.additionalDeliveryIds
          )
        }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        activeReservations.deliveryTime || activeReservations.deliveryUserName
      "
    >
      <p>{{ $t('delivered') }}</p>
      <span
        >{{ activeReservations.deliveryUserName }}
        {{ dateTime(activeReservations.deliveryTime) }}</span
      >
    </div>
    <div class="info" v-if="activeReservations.fulfillment_order_id">
      <p>{{ $t('fulfillment_order_id') }}</p>
      <span>{{ activeReservations.fulfillment_order_id }}</span>
    </div>
    <div
      class="info"
      v-if="activeReservations?.lockerId || activeReservations?.shelf"
    >
      <p>{{ $t('lockerIdOrShelf') }}</p>
      <span>{{ getLockerIdOrShelf(activeReservations) }}</span>
    </div>
    <div class="info" v-if="activeReservations.is_drug">
      <p>{{ $t('includesDrug') }}</p>
      <span>{{ getIsDrud(activeReservations.is_drug) }}</span>
    </div>
    <div class="info" v-if="activeReservations.order_id">
      <p>{{ $t('order_id') }}</p>
      <span>{{ activeReservations.order_id }}</span>
    </div>
    <div class="info" v-if="activeReservations.reservedTime">
      <p>{{ $t('reserved') }}</p>
      <span>{{ dateTime(activeReservations.reservedTime) }}</span>
    </div>
    <div class="info" v-if="activeReservations.pickupTime">
      <p>{{ $t('pickedUp') }}</p>
      <span>{{ dateTime(activeDelivery.pickupTime) }}</span>
    </div>
    <div class="info" v-if="activeReservations.assignedTime">
      <p>{{ $t('assignedTime') }}</p>
      <span>{{ dateTime(activeReservations.assignedTime) }}</span>
    </div>
    <div class="info" v-if="activeReservations.orderExpired">
      <p>{{ $t('orderExpired') }}</p>
      <span>{{ activeReservations.orderExpired }}</span>
    </div>
    <div class="info" v-if="activeReservations.causeOfAlarm">
      <p>{{ $t('causeOfAlarm') }}</p>
      <span>{{ activeReservations.causeOfAlarm }}</span>
    </div>
    <div class="info" v-if="activeReservations.resendSMSCounter">
      <p>{{ $t('resendSMSCounter') }}</p>
      <span>{{ activeReservations.resendSMSCounter }}</span>
    </div>
    <div class="info" v-if="activeReservations.resendSMSTimestamps">
      <p>{{ $t('resendSMSTimestamps') }}</p>
      <span>{{ dateTime(isLastTime) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import moment from 'moment';

import { DataReservations } from '@/store/modules/pharmacy/types';

@Options({
  name: 'InfoAboutDelivery',
  emits: ['getDecodedSsn'],
  props: ['activeReservations', 'showDecodedSsn'],
  data() {
    return {
      isSSN: false
    };
  },
  computed: {
    isLastTime() {
      return this.activeReservations.resendSMSTimestamps[
        this.activeReservations.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },
  methods: {
    dateTime(value: string) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getLockerId(item: Array<string>) {
      return item?.join(', ');
    },
    getLockerIdOrShelf(data: DataReservations) {
      if (data?.shelf) {
        return data?.shelf
          .map((item: string) =>
            item === 'cooling' ? this.$t('cooling') : item.toUpperCase()
          )
          .join(', ');
      } else {
        return this.getLockerId(data?.lockerId);
      }
    },
    getIsDrud(value: boolean) {
      if (value) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    },
    showSsn() {
      this.$emit('getDecodedSsn', this.activeReservations.deliveryId);
      this.isSSN = true;
    },
    getDataSSN() {
      if (this.isSSN) {
        return this.showDecodedSsn?.length
          ? this.showDecodedSsn
          : this.$t('noSsn');
      } else {
        return '************';
      }
    }
  }
})
export default class InfoAboutDelivery extends Vue {}
</script>

<style lang="scss" scoped>
.infoAboutDelivery {
  width: 283px;
  height: 246px;
  padding: 16px;
  background-color: $light-grey;
  border: 1px solid $border;
  border-radius: 8px;
  overflow-y: scroll;
  .info {
    margin-bottom: 25px;
    background-color: $light-grey;
    p {
      color: $label;
      line-height: 14px;
      font-size: $twelveSize;
      background-color: $light-grey;
    }
    span {
      color: $mid-grey;
      line-height: 14px;
      font-size: $fourteenSize;
      background-color: $light-grey;
    }
    .ssn_btn {
      width: 0;
      height: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
